import { render, staticRenderFns } from "./AddDepartment.vue?vue&type=template&id=d7203f1c&scoped=true"
import script from "./AddDepartment.vue?vue&type=script&lang=js"
export * from "./AddDepartment.vue?vue&type=script&lang=js"
import style0 from "./AddDepartment.vue?vue&type=style&index=0&id=d7203f1c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7203f1c",
  null
  
)

export default component.exports